module.exports = __webpack_public_path__ + "img/bank.0921556d.svg";